// ESF OTOMOTİV - Ürün Kategorileri (Basitleştirilmiş yapı)

export const PRODUCT_CATEGORIES = [
  {
    id: 'motor-yenileme-ekipmanlari',
    name: 'MOTOR YENİLEME EKİPMANLARI',
    description: 'Motor yenileme için ekipman ve aksesuarlar',
    subcategories: [
      { id: 'honlama-kafalari', name: 'Honlama Kafaları', count: 8 },
      { id: 'kater-gruplari', name: 'Kater Grupları', count: 12 },
      { id: 'raybalar', name: 'Raybalar', count: 6 },
      { id: 'test-kontrol-olcu', name: 'Test, Kontrol ve Ölçü Aletleri', count: 15 },
      { id: 'polisaj-makinasi', name: 'Polisaj Makinası', count: 3 },
      { id: 'yay-toplama', name: 'Yay Toplama', count: 4 },
      { id: 'acili-baglama-ayaklari', name: 'Açılı Bağlama Ayakları', count: 5 },
      { id: 'subap-yuvasi-isleme', name: 'Subap Yuvası İşleme', count: 7 },
      { id: 'yardimci-ekipman', name: 'Yardımcı Ekipman', count: 10 },
    ],
  },
  {
    id: 'motor-yenileme-makinalari',
    name: 'MOTOR YENİLEME MAKİNALARI',
    description: 'Motor yenileme sürecinde kullanılan endüstriyel makinalar',
    subcategories: [
      { id: 'krank-taslama', name: 'Krank Taşlama Makinası', count: 2 },
      { id: 'silindir-kapagi-yuvasi-isleme', name: 'Silindir Kapağı Yuvası İşleme Makinası', count: 2 },
      { id: 'honlama-makinalari', name: 'Honlama Makinaları', count: 3 },
      { id: 'anayatak-kol-barasi', name: 'Anayatak ve Kol Barası', count: 4 },
      { id: 'yuzey-taslama-frezeleme', name: 'Yüzey Taşlama ve Frezeleme', count: 3 },
      { id: 'yikama-makinalari', name: 'Yıkama Makinaları', count: 3 },
      { id: 'subap-taslama-makinasi', name: 'Subap Taşlama Makinası', count: 1 },
      { id: 'sim-taslama-makinasi', name: 'Şim Taşlama Makinası', count: 1 },
    ],
  },
  {
    id: 'motor-yenileme-yedek-parcalari',
    name: 'MOTOR YENİLEME YEDEK PARÇALARI',
    description: 'Makine ve ekipmanlar için yedek parçalar',
    subcategories: [
      { id: 'ekipman-yedek-parcalari', name: 'Ekipman Yedek Parçaları', count: 15 },
      { id: 'makina-yedek-parcalari', name: 'Makina Yedek Parçaları', count: 20 },
      { id: 'sarf-malzemeler', name: 'Sarf Malzemeler', count: 30 }
    ],
  },
  {
    id: 'otomotiv-servis-elemanlari',
    name: 'OTOMOTİV SERVİS ELEMANLARI',
    description: 'Servis ve bakım ekipmanları',
    subcategories: [
      { id: 'diyagnoz-aletleri', name: 'Diyagnoz Aletleri', count: 10 },
      { id: 'kaldirma-ekipmanlari', name: 'Kaldırma Ekipmanları', count: 5 },
      { id: 'el-aletleri', name: 'El Aletleri', count: 50 },
      { id: 'yaglama-ekipmanlari', name: 'Yağlama Ekipmanları', count: 8 }
    ],
  },
  {
    id: 'ikinci-el-satilik-urunler',
    name: 'İKİNCİ EL SATILIK ÜRÜNLER',
    description: 'Test edilmiş ve satılık ikinci el ürünler',
    subcategories: [
      { id: 'ikinci-el-makinalar', name: 'İkinci El Makinalar', count: 4 },
      { id: 'ikinci-el-ekipmanlar', name: 'İkinci El Ekipmanlar', count: 12 },
      { id: 'firat-taslama-tezgahi', name: 'Fırat Taşlama Tezgahı', count: 1 }
    ],
  },
]

export const COMPANY_STATS = [
  { id: 'experience', number: "2017→2022", label: "Dönüşüm ve Üretim" },
  { id: 'happyCustomers', number: "1000+", label: "Mutlu Müşteri" },
  { id: 'productVariety', number: "500+", label: "Ürün Çeşidi" },
  { id: 'techSupport', number: "7/24", label: "Teknik Destek" },
];

export const SERVICES = [
  {
    id: 'tech-consulting',
    icon: "fas fa-tools",
    title: "Teknik Danışmanlık",
    description:
      "Uzman ekibimizle 7/24 teknik destek ve danışmanlık hizmeti sunuyoruz.",
  },
  {
    id: 'fast-delivery',
    icon: "fas fa-shipping-fast",
    title: "Hızlı Teslimat",
    description:
      "Türkiye genelinde hızlı ve güvenli teslimat ağımızla siparişlerinizi ulaştırıyoruz.",
  },
  {
    id: 'installation',
    icon: "fas fa-cog",
    title: "Kurulum ve Montaj",
    description:
      "Satın aldığınız makinaların profesyonel kurulum ve montaj hizmetini sağlıyoruz.",
  },
  {
    id: 'warranty',
    icon: "fas fa-shield-alt",
    title: "Garanti ve Servis",
    description:
      "Tüm ürünlerimiz için kapsamlı garanti ve satış sonrası servis desteği.",
  },
  {
    id: 'training',
    icon: "fas fa-graduation-cap",
    title: "Eğitim Hizmetleri",
    description:
      "Ekipman kullanımı konusunda personel eğitimi ve sertifikasyon programları.",
  },
  {
    id: 'custom-solutions',
    icon: "fas fa-handshake",
    title: "Özel Çözümler",
    description:
      "İhtiyaçlarınıza özel tasarım ve üretim çözümleri geliştiriyoruz.",
  },
];

export const REFERENCES = [
  {
    icon: "fas fa-building",
    name: "Bosch Türkiye",
    description: "Otomotiv parçaları tedarikçisi",
  },
  {
    icon: "fas fa-industry",
    name: "Ford Otosan",
    description: "Otomotiv üreticisi",
  },
  {
    icon: "fas fa-car",
    name: "Tofaş",
    description: "Otomobil üreticisi",
  },
  {
    icon: "fas fa-cogs",
    name: "Mahle Türkiye",
    description: "Motor parçaları üreticisi",
  },
  {
    icon: "fas fa-wrench",
    name: "Beyçelik Gestamp",
    description: "Otomotiv sanayi",
  },
  {
    icon: "fas fa-truck",
    name: "BMC",
    description: "Ticari araç üreticisi",
  },
];
